import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
interface Option {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options: Option[];
  placeholder?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  helperText,
  className = '',
  options,
  placeholder,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-128">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-129">
            {label}
          </label>}
        <div className="relative" data-id="element-130">
          <select ref={ref} className={`
              block w-full h-10 rounded-lg border bg-white text-sm transition-colors appearance-none
              focus:outline-none focus:ring-2 focus:ring-[#1B6B3A]/20 focus:border-[#1B6B3A]
              disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed disabled:border-gray-200
              ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500/20 text-red-900' : 'border-gray-300 text-gray-900'}
              pl-3 pr-10
              ${className}
            `} {...props} data-id="element-131">
            {placeholder && <option value="" disabled selected hidden data-id="element-132">
                {placeholder}
              </option>}
            {options.map(option => <option key={option.value} value={option.value} data-id="element-133">
                {option.label}
              </option>)}
          </select>
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-400" data-id="element-134">
            <ChevronDown className="w-4 h-4" data-id="element-135" />
          </div>
        </div>
        {error && <p className="mt-1.5 text-sm text-red-600" data-id="element-136">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-gray-500" data-id="element-137">{helperText}</p>}
      </div>;
});
Select.displayName = 'Select';